export default "__VITE_ASSET__BvQd3xmN__"